export const fmtDur = (sec) => {
  const m = Math.floor(sec / 60);
  const s = sec % 60;
  if (m && s) return `${m} min ${s} sec`;
  if (m) return `${m} min`;
  return `${s} sec`;
};
